"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchData = void 0;
const helpers_1 = require("../helpers");
const CawData_1 = require("./CawData");
const getSearchData = (input) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    try {
        if (!input) {
            throw new helpers_1.ContentError('Invalid parameters - input required');
        }
        if (!input.content) {
            throw new helpers_1.ContentError('Invalid parameters - content required');
        }
        const caw = CawData_1.buildCawData({
            language: input.language,
            embedded: false,
            pp: input.pp,
            employee: input.employee,
            content: {
                regions: input.content.regions,
                status: input.content.status,
                calendarAvailability: input.content.calendarAvailability,
                employeeCalendarAvailability: input.content.employeeCalendarAvailability,
                globalSettings: input.content.globalSettings,
            },
            customizations: input.cawCustomizations,
            cawState: input.cawState,
        }, input.content.property);
        const searchDataResponse = {
            bookingMessages: [],
            sisterProperties: [],
            caw,
            webChat: {
                enabled: false,
            },
            suppressBookingError: false,
        };
        const propertyMetaData = (_a = input.content.property) === null || _a === void 0 ? void 0 : _a.metadata;
        const error = helpers_1.getError({
            language: input.language,
            employee: !!input.employee,
            propertyMetaData,
            supplierErrors: (_b = input.oj) === null || _b === void 0 ? void 0 : _b.supplierErrors,
            apiErrors: (_c = input.oj) === null || _c === void 0 ? void 0 : _c.apiErrors,
        });
        if (error.messageDictKey.key && !input.employee) {
            if ((_d = input.content.property) === null || _d === void 0 ? void 0 : _d.metadata.sisterProperties) {
                searchDataResponse.sisterProperties = (_e = input.content.property) === null || _e === void 0 ? void 0 : _e.metadata.sisterProperties.split(',').map(code => {
                    const sisterPropertyName = input.content.regions.regions.reduce((name, region) => {
                        if (name) {
                            return name;
                        }
                        return region.properties.reduce((propertyName, property) => {
                            if (propertyName) {
                                return propertyName;
                            }
                            if (property.owsCode === code) {
                                return property.shortName || '';
                            }
                            return propertyName;
                        }, '');
                    }, '');
                    return {
                        name: helpers_1.formatBeverlyWilshire(sisterPropertyName),
                        owsCode: code,
                    };
                });
            }
            if (error.errorCode && helpers_1.availabilityErrorCodes.includes(error.errorCode)) {
                if ((_f = input.content.property) === null || _f === void 0 ? void 0 : _f.soldOutBookingMessages) {
                    searchDataResponse.bookingMessages =
                        ((_h = (_g = input.content.property) === null || _g === void 0 ? void 0 : _g.soldOutBookingMessages.messages) === null || _h === void 0 ? void 0 : _h.map(message => {
                            return {
                                title: message.title,
                                body: helpers_1.formatBeverlyWilshire(message.body),
                            };
                        })) || [];
                    if (searchDataResponse.bookingMessages.length) {
                        searchDataResponse.suppressBookingError = true;
                    }
                }
            }
            else if ((_j = input.content.property) === null || _j === void 0 ? void 0 : _j.availabilityBookingMessages) {
                searchDataResponse.bookingMessages =
                    ((_l = (_k = input.content.property) === null || _k === void 0 ? void 0 : _k.availabilityBookingMessages.messages) === null || _l === void 0 ? void 0 : _l.map(message => {
                        return {
                            title: message.title,
                            body: helpers_1.formatBeverlyWilshire(message.body),
                        };
                    })) || [];
            }
        }
        if (error.messageDictKey.key) {
            searchDataResponse.bookingError = {
                labelDictKey: error.labelDictKey,
                messageDictKey: error.messageDictKey,
                descriptionDictKey: error.descriptionDictKey,
                contactReservations: error.contactReservations,
                field: error.field,
            };
        }
        else if (!searchDataResponse.caw.cawConfig.disableFlexDates &&
            !!((_m = input.cawState) === null || _m === void 0 ? void 0 : _m.flexDatesWindow) &&
            !!((_o = input.cawState) === null || _o === void 0 ? void 0 : _o.promoCode)) {
            searchDataResponse.bookingError = {
                labelDictKey: helpers_1.setDictionaryKey('Error'),
                messageDictKey: helpers_1.setDictionaryKey('error.E0327', [], true),
                field: 'discountCode',
            };
        }
        searchDataResponse.webChat = { enabled: false };
        if ((_p = propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.webChatConfig) === null || _p === void 0 ? void 0 : _p['chatinrbf-bookingflow']) {
            const webChat = propertyMetaData.webChatConfig['chatinrbf-bookingflow'];
            searchDataResponse.webChat = {
                enabled: Boolean(webChat.enabled && !input.employee && !input.pp),
                id: webChat.id,
                integrationId: webChat.integrationId,
                propertyName: propertyMetaData.landingPagePropertyName,
                propertyCode: propertyMetaData.owsCode,
            };
            if ((_r = (_q = propertyMetaData.upcomingTrip) === null || _q === void 0 ? void 0 : _q.desktopImage) === null || _r === void 0 ? void 0 : _r.croppedPath) {
                searchDataResponse.webChat.propertyImage = {
                    path: (_t = (_s = propertyMetaData.upcomingTrip) === null || _s === void 0 ? void 0 : _s.desktopImage) === null || _t === void 0 ? void 0 : _t.croppedPath,
                };
            }
        }
        if (input.pp) {
            searchDataResponse.contactUs = {
                url: '/contact/property_key_contacts/',
                textDictKey: helpers_1.setDictionaryKey('Contact Us'),
            };
        }
        return searchDataResponse;
    }
    catch (err) {
        if (err instanceof helpers_1.ContentError) {
            return { error: err };
        }
        throw err;
    }
};
exports.getSearchData = getSearchData;
